import { map } from 'lodash';
import { v4 as uuid } from 'uuid';
import { epoch, utc } from '../../util/datetime';
import { toUUID } from '../../util/transform';
import type { ILodgementApplication } from './Lodgement.interface';
import LodgementBackChannelHistory from './LodgementBackChannelHistory';
import LodgementLodgeHistory from './LodgementLodgeHistory';

export default class Lodgement implements ILodgementApplication {
  id: string;
  idOrganization: string;
  idTicket: string;
  idLender: string;
  lenderAssignedId: string;
  applicationId: string;
  ticket: any;
  loan: any;
  contacts: Array<any>;
  type: string;
  status: string;
  lodgeHistory: Array<LodgementLodgeHistory>;
  backChannelMessagesHistory: Array<LodgementBackChannelHistory>;
  isSubmitted: boolean;
  isActive: boolean;
  timeStamp: number;

  static build = (data: ILodgementApplication) => new Lodgement(data);
  static blank = () => new Lodgement({ id: uuid() });

  /**
   * Constructor
   * @param {ILodgementApplication} data
   */
  constructor(data?: ILodgementApplication) {
    this.id = toUUID(data?.id);
    this.idOrganization = toUUID(data?.idOrganization);
    this.idTicket = data?.idTicket || undefined;
    this.idLender = data?.idLender || undefined;
    this.lenderAssignedId = data?.lenderAssignedId || undefined;
    this.applicationId = data?.applicationId || undefined;
    this.ticket = data?.ticket || undefined;
    this.loan = data?.loan || undefined;
    this.contacts = data?.contacts;
    this.type = data?.type || undefined;
    this.status = data?.status || undefined;
    this.lodgeHistory = map(data?.lodgeHistory, (obj) => new LodgementLodgeHistory(obj));
    this.backChannelMessagesHistory = map(
      data?.backChannelMessagesHistory,
      (obj) => new LodgementBackChannelHistory(obj)
    );
    this.isSubmitted = data?.isSubmitted === true;
    this.isActive = data?.isActive === true;
    this.timeStamp = epoch(utc(data?.timeStamp));
  }
}
